/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum EstimatedDuration {
  ONE_MONTH = "ONE_MONTH",
  TWO_MONTHS = "TWO_MONTHS",
  THREE_MONTHS = "THREE_MONTHS",
  FOUR_MONTHS = "FOUR_MONTHS",
  FIVE_MONTHS = "FIVE_MONTHS",
  SIX_MONTHS = "SIX_MONTHS",
  SEVEN_MONTHS = "SEVEN_MONTHS",
  EIGHT_MONTHS = "EIGHT_MONTHS",
  NINE_MONTHS = "NINE_MONTHS",
  TEN_MONTHS = "TEN_MONTHS",
  ELEVEN_MONTHS = "ELEVEN_MONTHS",
  TWELVE_MONTHS_PLUS = "TWELVE_MONTHS_PLUS",
}

export const EstimatedDurationDisplay: Record<EstimatedDuration, string> = {
  [EstimatedDuration.ONE_MONTH]: "One Month",
  [EstimatedDuration.TWO_MONTHS]: "Two Months",
  [EstimatedDuration.THREE_MONTHS]: "Three Months",
  [EstimatedDuration.FOUR_MONTHS]: "Four Months",
  [EstimatedDuration.FIVE_MONTHS]: "Five Months",
  [EstimatedDuration.SIX_MONTHS]: "Six Months",
  [EstimatedDuration.SEVEN_MONTHS]: "Seven Months",
  [EstimatedDuration.EIGHT_MONTHS]: "Eight Months",
  [EstimatedDuration.NINE_MONTHS]: "Nine Months",
  [EstimatedDuration.TEN_MONTHS]: "Ten Months",
  [EstimatedDuration.ELEVEN_MONTHS]: "Eleven Months",
  [EstimatedDuration.TWELVE_MONTHS_PLUS]: "Twelve Months Plus",
};
